export default __webpack_public_path__ + "static/media/11AW2FEB66.51aacb8f.jpg";